import React, { Fragment, Component } from "react";
import styled, { keyframes } from "styled-components";
import HeadlineSegment from "./HeadlineSegment";
import TransitionHandler from "../containers/TransitionHandler";
import NeedsIntersection from "../containers/NeedsIntersection";
import ShadowHashlink from "../containers/ShadowHashlink";
import { basename } from "path";
import { ResponsiveImage, load } from "../containers/ProgressiveHelpers";

const Relative = styled.div`
  position: relative;
`;

const Container = styled.div`
  --picture-size: 15em;

  display: grid;
  grid-template-columns: repeat(auto-fit, var(--picture-size));
  grid-gap: 7.5em;
  width: 100%;
  padding: 7.5em;
  justify-content: space-around;
  box-sizing: border-box;

  @media (max-width: 400px) {
    padding: 5em;
  }
  @media (max-width: 360px) {
    font-size: 1.25em;
    grid-gap: 2.5em;
  }
`;

const MemberContainer = styled.div`
  display: grid;
  grid-template-rows: var(--picture-size) 1fr;
  grid-template-columns: var(--picture-size);
`;

const MemberImage = styled.img`
  width: 100%;
  height: 100%;
  grid-column: span 1;
  grid-row: span 1;
  border-radius: 50%;
  object-fit: cover;
  box-sizing: border-box;
`;

const MemberName = styled.div`
  font-size: 1.5em;
  font-family: Raleway, sans-serif;
  font-weight: normal;
  padding: 1em;
  text-align: center;
`;

const TeamMember = ({ name, src, srcSet, sizes, ...filteredProps }) => (
  <MemberContainer {...filteredProps}>
    <MemberImage src={src} srcSet={srcSet} sizes={sizes} />
    <MemberName children={name} />
  </MemberContainer>
);

export default ({ locality, cms }) => {
  const teams = ["secondary-locality", "primary-locality"].map(localityName =>
    cms[localityName]["team-members"].map(member => ({
      name: member.name,
      "profile-photo": load(member["profile-photo"])
    }))
  );

  return (
    <Fragment>
      <HeadlineSegment children={cms["team-section-title"]} />
      <Relative>
        <ShadowHashlink id="team" offset="-50vh" mobileOffset="-25vh" />
        <NeedsIntersection>
          <Container>
            <TransitionHandler>
              {teams[locality === 0 ? 0 : 1].map(member => (
                <ResponsiveImage
                  key={member.name}
                  photo={member["profile-photo"]}
                >
                  <TeamMember name={member.name} />
                </ResponsiveImage>
              ))}
            </TransitionHandler>
          </Container>
        </NeedsIntersection>
      </Relative>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// /opt/build/repo/src/segments/TeamSegment.js